import { useMutation, useQueryClient } from "@tanstack/react-query";
import { fetchAPI } from "@coworker/app/src/hooks/API/tasks.service.helper";
import { CORE_SERVICE_URL } from "@coworker/app/src/hooks/API/core.service";

async function updateUserLastActiveAtByUid(uid: string) {
  const path = `users/${uid}/last-active-at`;
  const url = `${CORE_SERVICE_URL}/${path}`;
  return await fetchAPI("PUT", url, {});
}

export const useUpdateUserLastActiveAt = (uid: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => updateUserLastActiveAtByUid(uid),
    onSuccess: () => {
      return queryClient.invalidateQueries({
        queryKey: ["user", uid],
      });
    },
  });
};
